// ============================================================
// 原子（元素）定義
// 色は CPK 配色を暗背景向けに調整
// ============================================================

export const atoms = [
  { element: 'H', name: '水素', color: '#E6E6E6', category: '非金属' },
  { element: 'C', name: '炭素', color: '#606A75', category: '非金属' },
  { element: 'N', name: '窒素', color: '#3050F8', category: '非金属' },
  { element: 'O', name: '酸素', color: '#FF4D4D', category: '非金属' },
  { element: 'S', name: '硫黄', color: '#E0C020', category: '非金属' },
  { element: 'P', name: 'リン', color: '#FF8000', category: '非金属' },
  { element: 'F', name: 'フッ素', color: '#4FD44F', category: 'ハロゲン' },
  { element: 'Cl', name: '塩素', color: '#2FD02F', category: 'ハロゲン' },
  { element: 'Br', name: '臭素', color: '#B05A2C', category: 'ハロゲン' },
  { element: 'I', name: 'ヨウ素', color: '#9400D3', category: 'ハロゲン' },
  { element: 'Na', name: 'ナトリウム', color: '#AB5CF2', category: '金属' },
  { element: 'K', name: 'カリウム', color: '#8F40D4', category: '金属' },
  { element: 'Mg', name: 'マグネシウム', color: '#2ECC71', category: '金属' },
  { element: 'Ca', name: 'カルシウム', color: '#3DBF6B', category: '金属' },
]

const atomMap = Object.fromEntries(atoms.map((a) => [a.element, a]))

export const getAtomByElement = (element) => atomMap[element]

export const atomCategories = ['All', '非金属', 'ハロゲン', '金属']

/** 元素記号から色を得る（未定義はグレー） */
export const colorForElement = (element) =>
  atomMap[element]?.color || '#94A3B8'
